import { createApp } from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import { store as storeApp } from "./store";
import nascarData from "./js/nascarData.js";
import "./sass/App.scss";
import toast from "./js/toast.js";
import mapUtility from "./js/mapUtility.js";

export const store = new Vuex.Store({
  modules: {
    store: storeApp
  },
});

const app = createApp(App).use(store);

app.mount("#app");

window.onload = function () {
  //router.replace({ path: "/" });
  //router.go(-1);
};

window.onhashchange = function () {
  //router.replace({ path: "/" });
  window.location.reload(false);
};
window.timeInApp = 0;
window.started = Date.now();

const setVDimensions = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  let vw = window.innerWidth * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  document.documentElement.style.setProperty("--vw", `${vw}px`);
  document.documentElement.style.setProperty("--font-scale", `1`);
  store.commit("setTrueVH", vh);
  store.commit("setTrueVW", vw);
};

const setViewportHeight = () => {
  setVDimensions();
  // We listen to the resize event
  window.addEventListener("resize", () => {
    // We execute the same script as before
    setVDimensions();

    window.setTimeout(() => {
      setVDimensions();
    }, 500);
  });
};

//Logic to fix issues with camera feed freezing
const focusedPage = () => {
  window.started = Date.now();

  if (window.newWindow) window.newWindow.close();
  if (document.getElementsByTagName("video")[0])
    document.getElementsByTagName("video")[0].play();
  window.setTimeout(() => {
    if (document.getElementsByTagName("video")[0])
      document.getElementsByTagName("video")[0].play();
  }, 1500);
};

const blurPage = () => {
  window.timeInApp += Date.now() - window.started;
};

const processQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  store.commit("debugImageUploaderActive", urlParams.get('debugMode') != null)
};

window.onbeforeunload = () => {
  window.timeInApp += Date.now() - window.started;

  //TAGGED: Might not need this
  document.querySelector("body").dispatchEvent(new Event("cleanupEverything"));
};

window.addEventListener("focus", focusedPage);
window.addEventListener("blur", blurPage);

// — Input Constants —
const DPAD = {
  UP: 'ArrowUp', DOWN: 'ArrowDown',
  LEFT: 'ArrowLeft', RIGHT: 'ArrowRight',
  SELECT: 'Enter', BACK: 'Escape',
};

// — Focus Management —
function moveFocus(direction) {
  var focusables = Array.from(
    document.querySelectorAll('.focusable:not([disabled]):not(.hidden)')
  );
  if (!focusables.length){
    if (direction === 'up') window.dispatchEvent(new CustomEvent('to-minimized'));
    return;
  }

  var idx = focusables.indexOf(document.activeElement);
  if (idx === -1) { focusables[0].focus(); return; }
  if (idx === 0 && direction === 'up') {
    window.dispatchEvent(new CustomEvent('to-minimized'));
    return;
  }

  var next = (direction === 'up')
    ? (idx > 0 ? idx - 1 : focusables.length - 1)
    : (idx < focusables.length - 1 ? idx + 1 : 0);


  focusables[next].focus();
  focusables[next].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  console.log(next)
}

// — D-pad Listener —
document.addEventListener('keydown', function(e) {
  switch (e.key) {
    case DPAD.UP:    
      window.dispatchEvent(new CustomEvent('up-scroll')); 
      moveFocus('up');    
      break;
    case DPAD.DOWN:   
      window.dispatchEvent(new CustomEvent('down-scroll')); 
      moveFocus('down');  
      break;
    case DPAD.LEFT: 
      window.dispatchEvent(new CustomEvent('left-scroll'));
      moveFocus('left'); 
      break;
    case DPAD.RIGHT:
      window.dispatchEvent(new CustomEvent('right-scroll'));
      moveFocus('right'); 
    break;
    case DPAD.SELECT:
      if (document.activeElement.classList.contains('focusable')) {
        document.activeElement.click();
      }
      break;
    case DPAD.BACK:
      window.dispatchEvent(new CustomEvent('back'));
      break;
    default: return; // don't preventDefault on unhandled keys
  }
  e.preventDefault();
});

// Start the scene and catch any bubbled exceptions
const start = async () => {
  try {
    toast.init();
    mapUtility.init();
    await nascarData.init();
    setViewportHeight();
  } catch (e) {
    console.warn("error", "start", e);
    // store.commit("setGeneralError", true);
    store.commit("setAppFailed", true);
  }
};

start();

// catch any global errors
window.onerror = (e) => {
  console.warn("error", "window", e);
  // store.commit("setGeneralError", true);
  store.commit("setAppFailed", true);
};
